<template>
    <div class="flex flex-col">
        <div class="flex w-full justify-between ">
                        <div class="whitespace-nowrap font-semibold tracking-wide  text-gray-800">
                            Completed:
                        </div>
                        <div class="border-b-2 border-dotted border-gray-400 flex-grow mb-2 mx-1"></div>           
                        <div class="whitespace-nowrap flex flex-wrap gap-1 pb-1 justify-between tracking-wide items-center">
                            <div class="">
                                {{ completedStepRatio }}
                            </div>
                        </div>
                    </div>
        <div class="max-h-40 overflow-y-scroll flex flex-col">
            <div v-for="step in missingSteps" :key="step.id" class="m-1 border-b last:border-b-0 whitespace-nowrap p-1">
                {{ step.step_name }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';

const props = defineProps(['client', 'workFlowSteps'])


const missingSteps = computed(() => {
    const clientWorkflowSteps = props.client.workflow_steps.filter(workflowStep => workflowStep.completed_on).map(workflowStep => workflowStep.workflow_step.id)
    return props.workFlowSteps.filter((step) => {
        return step.required && !clientWorkflowSteps.includes(step.id)
    })
})

const completedStepRatio = computed(() => {
    let completedStepCount = props.client.workflow_steps.filter(workflowStep => workflowStep.completed_on && workflowStep.workflow_step.required && workflowStep.workflow_step.status == 'active').length
    let requiredStepCount = props.workFlowSteps.filter((step) => step.required).length + props.client.workflow_steps.filter(workflowStep => !workflowStep.completed_on).length - missingSteps.value.length
    return `${completedStepCount}/${requiredStepCount}`
})

</script>